export default class SideMenu {

    handleMenuToggle() {
        const menuToggler = document.querySelector('.navbar-toggler');
        const html = document.documentElement;

        if (menuToggler) {
            menuToggler.addEventListener('click', function () {
                this.classList.toggle('open');
                html.classList.toggle('disable-overflow');

                const navbar = this.parentElement.parentElement.parentElement;
                navbar.classList.toggle('open');

                const navbarItems =  navbar.querySelector('.navbar__items');

                console.log(navbarItems)
                navbarItems.classList.toggle('opened');
            });
        }
    }

    init() {
        this.handleMenuToggle();
    }
}
